import {Typography} from '@mui/material';

import styles from './Messages.module.css';

export const WarningMessage = ({message}) => <Typography className={styles.warningMessage}>{message}</Typography>;
